import { render, staticRenderFns } from "./batchUploadAttchmentDialog.vue?vue&type=template&id=5f6e56f0&scoped=true"
import script from "./batchUploadAttchmentDialog.vue?vue&type=script&lang=js"
export * from "./batchUploadAttchmentDialog.vue?vue&type=script&lang=js"
import style0 from "./batchUploadAttchmentDialog.vue?vue&type=style&index=0&id=5f6e56f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6e56f0",
  null
  
)

export default component.exports